import Vue from 'vue';
import Router from 'vue-router';
import Page from '@/components/Page';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Hello',
      component: Page,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js